// extracted by mini-css-extract-plugin
export default {"stickable":"p23R_yTDNFC5nDR9Ghzy","shadow":"AeSIEknv0xb1x8FGFfpn","placeHolderShimmer":"nZr5LC1HNhQvgoxREGFa"};